export const getBooleanClauseTokens = (value: string | undefined): string[] => {
  if (!value) return [];

  if (!value.includes('(')) return [value];

  const tokens: string[] = [];
  let current = '';
  let depth = 0;

  const pushCurrent = () => {
    const token = current.trim();
    if (token) tokens.push(token);
    current = '';
  };

  for (let index = 0; index < value.length; index += 1) {
    const char = value[index];

    if (char === '(') {
      if (depth > 0) current += char;
      depth += 1;
      continue;
    }

    if (char === ')') {
      depth -= 1;
      if (depth === 0) {
        pushCurrent();
      } else if (depth > 0) {
        current += char;
      }
      continue;
    }

    if (depth === 0) {
      const operator = value.slice(index).match(/^\s+(?:AND|OR)\s+/);
      if (operator) {
        pushCurrent();
        index += operator[0].length - 1;
        continue;
      }
    }

    current += char;
  }

  pushCurrent();
  return tokens;
};
